import React, { forwardRef } from 'react';
import { BaseButton, Typography } from 'fronton-react';
import { MagnifyingGlassIcon } from '@fronton/icons-react';
import { State } from 'components/header-legacy/components/searchbar/hooks/use-searchbar-transition';
import { ProductSuggestion, ServiceSuggestion } from 'types/suggestions';
import { pseudoInputContent, pseudoInput, pseudoInputIcon } from './styles';

export interface PseudoInputProps {
  expanded: boolean;
  transitionState: State;
  onClick: () => void;
  selectedItem: NonNullable<ServiceSuggestion | ProductSuggestion> | null;
  value: string;
  placeholder: string;
}

export const PseudoInput = forwardRef<HTMLButtonElement, PseudoInputProps>(
  (props: PseudoInputProps, innerRef) => {
    const { expanded, transitionState, onClick, selectedItem, value, placeholder } = props;

    const text = selectedItem?.phrase || value || placeholder || 'Поиск';

    return (
      <BaseButton
        ref={innerRef}
        type="button"
        className={pseudoInput}
        aria-label="Начать поиск по товарам"
        aria-hidden={expanded}
        hidden={transitionState !== 'collapsed'}
        data-qa-header-open-search-button=""
        data-qa="search-button"
        onClick={onClick}>
        <span className={pseudoInputIcon}>
          <MagnifyingGlassIcon />
        </span>

        <Typography color="text-primary" variant="m" size="body_long" className={pseudoInputContent}>
          {text}
        </Typography>
      </BaseButton>
    );
  }
);
